import { Component, OnInit, OnDestroy, ViewChild, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService, TranslationService } from 'src/app/shared';
import { NgForm } from '@angular/forms';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { Title } from '@angular/platform-browser';
import { PledgeDto } from '../../shared/pledge/dto/pledge.dto';
import { PledgeService } from '../../shared/pledge/pledge.service';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { ProfileAvatarInfoDto } from 'src/app/profiles/shared/dto/profile-avatar-info.dto';
import { PledgeEditBillingListComponent } from './pledge-edit-billing/pledge-edit-billing-list.component';

@Component({
  selector: 'wl-pledge-edit',
  templateUrl: './pledge-edit.component.html',
  styleUrls: ['./pledge-edit.component.less'],
    standalone: false
})
export class PledgeEditComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('detailsForm') detailsForm: NgForm;
  @ViewChild(PledgeEditBillingListComponent) _billingsComponent: PledgeEditBillingListComponent;

  pledgeId: number;
  pledge: PledgeDto;
  loadingPledge: boolean = true;

  profileAvatarInfo: ProfileAvatarInfoDto;
  loadingProfileAvatarInfo: boolean = true;

  isSaving: boolean;
  billingSaving = false;
  validToSave: boolean = true;

  private subs = new Subscription();
  constructor(
    public securityElementNames: SecurityElementNames,
    private _route: ActivatedRoute,
    private _router: Router,
    private _pledgeService: PledgeService,
    private _notificationService: NotificationService,
    private _title: Title,
    private _translationService: TranslationService,
    private _profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this._route.params.subscribe((params) => {
        if (params.pledgeId) {
          this.pledgeId = params.pledgeId;
          this.loadPledge();
        }
      })
    );
  }

  ngOnChanges() {
    this.loadProfileAvatarInfo();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  save() {
    this.isSaving = true;
    this._pledgeService
      .updatePledge(this.pledge)
      .then(() => {
        this._notificationService.translateSuccess('revenue.pledge.edit.saved-successfully');
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
        this.detailsForm?.form.markAsPristine();
      });
  }

  saveClicked() {
    this.detailsForm.ngSubmit.emit();
    // Hold the Save buttons until the billing saves (including any ARB create) have settled.
    this.billingSaving = true;
    Promise.resolve(this._billingsComponent.save())
      .catch(() => {
        // each billing reports its own failure
      })
      .finally(() => {
        this.billingSaving = false;
      });
  }

  cancel() {
    this._billingsComponent.loadBillings();
    if (this._router.getCurrentNavigation()?.previousNavigation.finalUrl) {
      this._router.navigateByUrl(this._router.getCurrentNavigation().previousNavigation.finalUrl);
    } else {
      this._router.navigate([`revenue/pledge-campaigns/${this.pledge.PledgeCampaignId}`]);
    }
  }

  private loadPledge() {
    this._pledgeService.getPledge(this.pledgeId).then((pledge: PledgeDto) => {
      this.pledge = pledge;
      this.loadProfileAvatarInfo();
      this.loadingPledge = false;
      this._title.setTitle(this._translationService.getInstantTitlecase('revenue.pledge.title') + ' ' + this.pledgeId);
    });
  }

  private loadProfileAvatarInfo() {
    this._profileService.getProfileAvatarInfo(this.pledge.ProfileId).then((ai: ProfileAvatarInfoDto) => {
      this.profileAvatarInfo = ai;
      this.loadingProfileAvatarInfo = false;
    });
  }
}
